import { inject, Injectable, signal } from '@angular/core';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { IWorkOrder } from '@app/domain/cmms-types/workorder-types';
import { WorkOrdersService } from '@app/pages/cmms/services/work-orders.service';
import { TranslateService } from '@tolgee/ngx';

@Injectable({
	providedIn: 'root',
})
export class AttachedEntityService {
	private readonly workOrdersService = inject(WorkOrdersService);
	private readonly notify = inject(IconSnackBarService);
	private readonly translate = inject(TranslateService);

	workorderData = signal<IWorkOrder | null>(null);

	linkEntityToWorkorder(entityType: 'setIncidents' | 'setRequests', entityId: string[]) {
		if (!this.workorderData()?.pk) {
			return;
		}
		this.workOrdersService
			.updateWorkOrder({
				pk: this.workorderData().pk,
				[entityType]: entityId,
			})
			.subscribe({
				next: () => {
					switch (entityType) {
						case 'setIncidents':
							this.notify.success(
								this.translate.instant('successfully_attached_incident', {
									count: entityId.length,
								})
							);
							break;
						case 'setRequests':
							this.notify.success(
								this.translate.instant('successfully_attached_request', {
									count: entityId.length,
								})
							);
							break;
					}
				},
				error: () => {
					this.notify.error(this.translate.instant('failed_to_save'));
				},
			});
	}
}
